// Import Packages
import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";

// Import Services
import appService from "../../../../services/ApplicationService/ApplicationService";

// Import Material UI
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import { Button, CircularProgress, Dialog, DialogTitle, Tooltip } from "@material-ui/core/";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Close from "@material-ui/icons/Close";

import { makeStyles } from '@material-ui/core/styles';
import ImageList from '@material-ui/core/ImageList';
import ImageListItem from '@material-ui/core/ImageListItem';
import ImageListItemBar from '@material-ui/core/ImageListItemBar';
import ListSubheader from '@material-ui/core/ListSubheader';
import IconButton from '@material-ui/core/IconButton';
import InfoIcon from '@material-ui/icons/Info';

// Import CSS
import './ChooseApplication.css'
import Search from "../../../../components/Search/Search";


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        backgroundColor: theme.palette.background.paper,
    },
    imageList: {
        width: 500,
        height: 450,
        alignItems: "center",
        justifyContent: "space-between"
    },
    imageListItem: {
        width: "48% !important",
        border: "1px solid #d9d9d9",
        boxShadow: "none !important"
    },
    icon: {
        color: 'rgba(255, 255, 255, 0.54)',
    },

    bottomSection: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
    },
    button: {
        border: "none",
        borderRadius: "5px",
        width: 100,
        height: 35,
        float: "right",
        "&:focus": {
            outline: "none",
        },
    },
    submit: {
        color: "white",
        marginLeft: 15,
        backgroundColor: "#079063",
        cursor: "pointer",
    }
}));

const ChooseApplication = ({ setSelectedApp, setOpen, setIsUpdateCredential }) => {
    const [applications, setApplications] = useState([]);
    const [searchApplications, setSearchApplications] = useState([]);
    const [loading, setLoading] = useState(false);

    const classes = useStyles();

    const { t } = useTranslation();

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true)
            const result = await appService.getApplications({
                connector_fields: "NOT NULL"
            })
            setLoading(false)
            if (result?.code === 200) {
                setApplications(result.data);
                setSearchApplications(result.data);
            }
        }
        fetchData().then(r => r);
    }, []);

    const handleClose = () => {
        setOpen(false);
    };


    return (
        <Dialog
            id="autom-addNew-modal"
            data-test="autom-add-new"
            open={true}
            onClose={handleClose}
            PaperProps={{
                style: {
                    width: 500,
                    minWidth: 400,
                    // padding: "16px 0",
                    minHeight: "20%",
                    maxHeight: "60%"
                },
            }}
        >
            <DialogTitle id="alert-dialog-title" style={{ padding: "24px 40px 24px 40px" }}>
                <div id="about-title" style={{ fontSize: '14px' }}>
                    Select an app to connect
                    <Button data-test="cancelautom-button" onClick={handleClose}>
                        <Close />
                    </Button>
                </div>
            </DialogTitle>
            <DialogContent className='application-select-container'>
                <Search data={applications} setSearchData={setSearchApplications} xs={12} sm={12} md={12} lg={12} xl={12} spacing={2}
                    searchKey={['name']} customClasses={["application-search-bar"]}>

                </Search>
                {loading ? <div className='new-credential-loading-container'><CircularProgress size={36} /></div>
                    : <div className='application-images-container'>
                        {searchApplications.map((item) => {
                            return <Tooltip title={item.name} placement="top">
                                <div draggable={false} className='select-app-image-container'
                                    onClick={() => {
                                        setSelectedApp(item);
                                        setIsUpdateCredential(true);
                                        setOpen(false);
                                    }}>
                                    <img draggable={false} src={item.image_path} alt={item.name} style={{
                                        left: 'auto',
                                        height: '100%',
                                        transform: 'translateX(0)',
                                        maxWidth: '100%'
                                    }} /></div>
                            </Tooltip>
                        })}
                    </div>}
                {/* <div className="application-select-container">

                </div> */}
                {/* <div className={classes.root}>
                    <ImageList rowHeight={180} className={classes.imageList}>

                        {applications.map((item) => (
                            <ImageListItem key={item.id} className={classes.imageListItem}
                                           style={{backgroundColor: "#efecec", boxShadow: "1px 1px 5px #c3c3c3"}}>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: '100%'
                                }}>
                                    <img src={item.image_path} alt={item.name} style={{
                                        left: 'auto',
                                        height: 'auto',
                                        transform: 'translateX(0)',
                                        maxWidth: '60%'
                                    }}/>
                                </div>
                                <ImageListItemBar
                                    title={item.name}
                                    // subtitle={<span>by: {item.author}</span>}
                                    actionIcon={
                                        <IconButton aria-label={`info about ${item.title}`} className={classes.icon}
                                                    onClick={() => {
                                                        setSelectedApp(item);
                                                        setOpen(false);
                                                    }}>
                                            <AddCircleOutlineIcon/>
                                        </IconButton>
                                    }
                                />
                            </ImageListItem>
                        ))}
                    </ImageList>
                </div> */}
            </DialogContent>

        </Dialog>
    );
}

export default ChooseApplication;
